module.exports = __webpack_public_path__ + "static/media/wd2.3eb059b4.jpeg";